import { render, staticRenderFns } from "./DomainStatusForm.vue?vue&type=template&id=0125d964&"
import script from "./DomainStatusForm.vue?vue&type=script&lang=js&"
export * from "./DomainStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainStatusForm.vue?vue&type=style&index=0&id=0125d964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports